var RouterService = /** @class */ (function () {
    function RouterService(optionService) {
        this.routes = {};
        this.sharedMiddlewares = [];
        this.routeMiddlewares = {};
        this.optionService = optionService;
    }
    RouterService.prototype.setErrors = function (errors, override) {
        if (override === void 0) { override = false; }
        this.optionService.setRoutingErrors(errors, override);
    };
    RouterService.prototype.setDisabled = function (disabledRoutes, override) {
        if (override === void 0) { override = false; }
        this.optionService.setDisabledRoutes(disabledRoutes, override);
    };
    RouterService.prototype.use = function () {
        var handlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            handlers[_i] = arguments[_i];
        }
        if (typeof handlers[0] === 'string') {
            var routeName = handlers.shift();
            this.routeMiddlewares['GET:' + routeName] = handlers;
            this.routeMiddlewares['POST:' + routeName] = handlers;
            this.routeMiddlewares['PUT:' + routeName] = handlers;
            this.routeMiddlewares['PATCH:' + routeName] = handlers;
            this.routeMiddlewares['DELETE:' + routeName] = handlers;
        }
        else {
            this.sharedMiddlewares = this.sharedMiddlewares.concat(handlers);
        }
    };
    RouterService.prototype.all = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['ALL', routeName].concat(handlers));
    };
    RouterService.prototype.get = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['GET', routeName].concat(handlers));
    };
    RouterService.prototype.post = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['POST', routeName].concat(handlers));
    };
    RouterService.prototype.put = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['PUT', routeName].concat(handlers));
    };
    RouterService.prototype.patch = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['PATCH', routeName].concat(handlers));
    };
    RouterService.prototype["delete"] = function (routeName) {
        var handlers = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handlers[_i - 1] = arguments[_i];
        }
        this.register.apply(this, ['DELETE', routeName].concat(handlers));
    };
    RouterService.prototype.route = function (method, routeName) {
        var notFoundHandler = function (req, res) {
            try {
                return res.render('errors/404');
            }
            catch (error) {
                return res.html("\n\t\t\t\t\t<h1>404!</h1>\n\t\t\t\t\t<p>Not found.</p>\n\t\t\t\t");
            }
        };
        // check if route is disabled
        if (this.disabled(method, routeName)) {
            return [notFoundHandler];
        }
        var handler = this.routes[method + ':' + routeName] || notFoundHandler;
        var handlers = this.routeMiddlewares[method + ':' + routeName] || [];
        // shared middlewares
        handlers = this.sharedMiddlewares.concat(handlers);
        // main handler
        handlers.push(handler);
        return handlers;
    };
    RouterService.prototype.register = function (method, routeName) {
        var handlers = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            handlers[_i - 2] = arguments[_i];
        }
        // remove invalid handlers
        for (var i = 0; i < handlers.length; i++) {
            if (!handlers[i] || (i !== 0 && !(handlers[i] instanceof Function))) {
                handlers.splice(i, 1);
            }
        }
        // register
        method = method || 'ALL';
        var handler = handlers.pop();
        if (method === 'ALL' || method === 'GET') {
            this.routes['GET:' + routeName] = handler;
            this.routeMiddlewares['GET:' + routeName] = handlers;
        }
        if (method === 'ALL' || method === 'POST') {
            this.routes['POST:' + routeName] = handler;
            this.routeMiddlewares['POST:' + routeName] = handlers;
        }
        if (method === 'ALL' || method === 'PUT') {
            this.routes['PUT:' + routeName] = handler;
            this.routeMiddlewares['PUT:' + routeName] = handlers;
        }
        if (method === 'ALL' || method === 'PATCH') {
            this.routes['PATCH:' + routeName] = handler;
            this.routeMiddlewares['PATCH:' + routeName] = handlers;
        }
        if (method === 'ALL' || method === 'DELETE') {
            this.routes['DELETE:' + routeName] = handler;
            this.routeMiddlewares['DELETE:' + routeName] = handlers;
        }
    };
    RouterService.prototype.disabled = function (method, routeName) {
        var disabledRoutes = this.optionService.getDisabledRoutes();
        var status = false;
        // cheking value (against disabledRoutes)
        var value = method.toLowerCase() + ':' + routeName;
        var valueUppercase = method.toUpperCase() + ':' + routeName;
        var valueSpaced = method.toLowerCase() + ' ' + routeName;
        var valueSpacedUppercase = method.toUpperCase() + ' ' + routeName;
        var values = [
            value,
            valueUppercase,
            (value).replace(':/', ':'),
            (valueUppercase).replace(':/', ':'),
            valueSpaced,
            valueSpacedUppercase,
            (valueSpaced).replace(' /', ' '),
            (valueSpacedUppercase).replace(' /', ' '),
        ];
        // check
        for (var i = 0; i < values.length; i++) {
            if (disabledRoutes.indexOf(values[i]) > -1) {
                status = true;
            }
        }
        return status;
    };
    return RouterService;
}());
export { RouterService };
